import { Button } from '@wix/design-system';
import React, { useEffect } from 'react';
import { AssistantMessage } from '../shared/AssistantMessage/AsistantMessage';
import styles from './optionSelector.scss';

import type { WidgetComponent } from '@wix/chat-widget-common-widgets';
import { ACTIONS } from '../../constants';

interface OptionSelectorProps {
  text: string;
  buttons: { label: string; value: string }[];
}

export const OptionSelector: WidgetComponent<OptionSelectorProps> = ({
  data: { text, buttons },
  context: { send, onWidgetAction },
}) => {
  useEffect(() => {
    onWidgetAction(OPTION_SELECTOR, { action: ACTIONS.WIDGET_LOAD });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AssistantMessage text={text}>
      {buttons.map((button) => (
        <div className={styles.optionSelector__item}>
          <Button
            skin="ai"
            size="small"
            priority="secondary"
            onClick={() => {
              send(button.value);
              onWidgetAction?.(OPTION_SELECTOR, {
                action: ACTIONS.BUTTON_CLICK,
                value: button.label,
              });
            }}
          >
            {button.label}
          </Button>
        </div>
      ))}
    </AssistantMessage>
  );
};

export const OPTION_SELECTOR = 'OPTION_SELECTOR';
